import { useEffect, useState } from 'react';
import { loadHelloVideo } from './helloVideoLoader';

/** { [userId]: true } for users with an approved hello video (batched + cached loader). */
const useHelloVideoMap = (userIds = []) => {
  const key = (userIds || []).filter(Boolean).join(',');
  const [map, setMap] = useState({});
  useEffect(() => {
    let live = true;
    const ids = key ? key.split(',') : [];
    Promise.all(ids.map(id => loadHelloVideo(id).then(v => [id, !!v]))).then(rows => {
      if (live) setMap(Object.fromEntries(rows.filter(([, has]) => has)));
    });
    return () => {
      live = false;
    };
  }, [key]);
  return map;
};

export default useHelloVideoMap;
